import { AsyncPipe } from '@angular/common';
import { Component, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { Subject } from 'rxjs';
import { SynlabHeaderService } from '../../../../../../../synlab-access-ui-components/synlab-header/synlab-header.service';
import { RightSidebarComponent } from "../right-sidebar/right-sidebar.component";
import { NavbarService } from './navbar.service';
import { RightSidebarMenuComponent } from '../right-sidebar-menu/right-sidebar-menu.component';
import { RouterModule } from '@angular/router';
import { LayoutService } from '../layout-service/layout.service';
import { Claim } from '../../../../../../../synlab-access-ui-components/core';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [AsyncPipe, TranslocoModule, RightSidebarComponent, RightSidebarMenuComponent, RouterModule],
  providers: [SynlabHeaderService],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent implements OnInit, OnDestroy {

  private readonly layoutService = inject(LayoutService);

  private readonly navbarService = inject(NavbarService);

  @Input()
  public userName: string = '';

  @Input()
  public currentLangCode: string = '';

  @Input()
  public logoUrl: string = '';

  @Output()
  public logOut = new Subject<void>();

  @Input()
  public currentUserClaims: Claim[] = [];

  @Input()
  public logoRedirectUrl: string = '';

  public readonly links$ = this.headerService.links$;

  public readonly showRightSidebar = this.layoutService.showRightSidebar;

  public readonly sidebarView = this.layoutService.sidebar;

  public readonly isNavbarHidden = this.navbarService.isHidden;

  private readonly onDestroy$ = new Subject<void>();

  @Input()
  public selectedMpiId: string = '';

  @Input()
  public readonly wards: any[] = [];

  constructor(private readonly headerService: SynlabHeaderService) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  public formatUrlWithLangCode(url: string | null) {
    if (!url) return url;

    const addQueryParam = (url: string, param: string, value: string) => {
      try {
        const urlObj = new URL(url);
        if (!urlObj.searchParams.has(param) && value) {
            urlObj.searchParams.append(param, value);
        }
        return urlObj.toString();
      } catch (error) {
        return url;
      }
    }

    return addQueryParam(url, 'langCode', this.currentLangCode);
  }
}
